export const ROOT_CONTAINER_ID = 'root-container-id';

// Assuming these values were large enough to get a usable resolution for the download file.
// Increasing this has a performance tradeoff.
export const DESKTOP_MAX_CONTAINER_WIDTH = 5000;
export const DESKTOP_MAX_CONTAINER_HEIGHT = 5000;

export const MOBILE_MAX_CONTAINER_WIDTH = 9000;
export const MOBILE_MAX_CONTAINER_HEIGHT = 9000;
